import BaseApi from "./BaseApi";

export default class ChapterClass extends BaseApi{
    construct() {}
    
 
    static async search(params) {
        return await ChapterClass.getAxiosInstance().get(ChapterClass.getFullApiUrl(),{params: params});
    }

    static async create(params) {
        return await ChapterClass.getAxiosInstance().post(ChapterClass.getFullApiUrl(),params);
    }

    static async find(id) {
        return await ChapterClass.getAxiosInstance().get(ChapterClass.getFullApiUrl() + id);
    }

    static async update(params, id) {
        return await ChapterClass.getAxiosInstance().put(ChapterClass.getFullApiUrl() + id,params);
    }

    static async delete(id) {
        return await ChapterClass.getAxiosInstance().delete(ChapterClass.getFullApiUrl() + id);
    }
    
    static async list(params) {
        let url = ChapterClass.getFullApiUrl() + "list";

        return ChapterClass.getAxiosInstance().get(url,{params: params});
    }

    
    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/chapter-class/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/chapter-class/";
    }
}
